var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideBarOperate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8001 10C14.8001 10.8837 15.5165 11.6 16.4001 11.6C17.2838 11.6 18.0001 10.8837 18.0001 10C18.0001 9.11634 17.2838 8.4 16.4001 8.4C15.5165 8.4 14.8001 9.11634 14.8001 10ZM14.8001 10H10.5001M14.8001 3.6C14.8001 4.48366 15.5165 5.2 16.4001 5.2C17.2838 5.2 18.0001 4.48366 18.0001 3.6C18.0001 2.71634 17.2838 2 16.4001 2C15.5165 2 14.8001 2.71634 14.8001 3.6ZM14.8001 3.6H5.49976M14.8001 16.4C14.8001 17.2837 15.5165 18 16.4001 18C17.2838 18 18.0001 17.2837 18.0001 16.4C18.0001 15.5163 17.2838 14.8 16.4001 14.8C15.5165 14.8 14.8001 15.5163 14.8001 16.4ZM14.8001 16.4H10.2001C9.75832 16.4 9.40015 16.0418 9.40015 15.6V4.4M5.19976 3.6C5.19976 4.48366 4.48341 5.2 3.59976 5.2C2.7161 5.2 1.99976 4.48366 1.99976 3.6C1.99976 2.71634 2.7161 2 3.59976 2C4.48341 2 5.19976 2.71634 5.19976 3.6Z",
    stroke: "#FAFAFA",
    strokeWidth: 1.68,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarOperate);
export default __webpack_public_path__ + "static/media/SideBarOperate.0fae3074aed9c313e9aef9b6b575dda9.svg";
export { ForwardRef as ReactComponent };